import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBucket"><Path d="M22 3H2V7H22V3Z" fill="currentColor"/><Path d="M3.6144 9L5.11745 21H18.8826L20.3857 9H3.6144Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBucket;
